import { useMemo } from "react";
import { createPortal } from "react-dom";

export const usePopup = (content: React.ReactNode) => {
  const Popup = useMemo(() => {
    // return a component only if there's content
    return () => {
      if (!content) return null;
      return createPortal(content, document.body);
    };
  }, [content]); // re-create Popup only if content changes

  return Popup;
};
